import { DataResponse, DataState } from '../interfaces/commonInterfaces';

async function GetPlazos(dataCotizacion: DataState): Promise<DataResponse> {
  const headers = {
    'Content-Type': 'application/json',
    'Authorization': '209d0c77ada6360d:bc139d4f710dfeee'
  };
  if (dataCotizacion.productTypeOption === 0) {
    const response = await fetch('https://finbe-gateway-api.herokuapp.com/products/api/v1/products/EF0E45C9-DA8B-E911-9183-005056BFCEC9', { headers });
    const result = await response.json();
    return result;
  } else {
    const response = await fetch('https://finbe-gateway-api.herokuapp.com/products/api/v1/products/42F2FD11-EBB0-E511-97CF-005056851F55', { headers });
    const result = await response.json();
    return result;
  }
}

export default GetPlazos;
